/*
  Complete the set: one tap add for the card rendered by
  snippets/lmc-complete-set.liquid. Loaded from the product page and from
  snippets/cart-drawer.liquid, so it guards against running twice.

  Adds through /cart/add.js and asks for the cart drawer sections in the same
  request, then hands them to Dawn's cart-drawer.renderContents, which is the
  same path the theme's own Add to cart uses. On the /cart page it reloads.
*/
(function () {
  if (window.__lmcSet) return;
  window.__lmcSet = true;

  function money(c) {
    var d = (c / 100).toFixed(2);
    return '$' + (d.slice(-3) === '.00' ? d.slice(0, -3) : d);
  }

  // Capture phase, so the cart's own change handlers never see this select.
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('.lmc-set__size') : null;
    if (!sel) return;
    e.stopPropagation();
    var card = sel.closest('.lmc-set');
    card.querySelector('.lmc-set__add').disabled = !sel.value;
    var opt = sel.options[sel.selectedIndex];
    if (opt && opt.dataset.price) card.querySelector('.lmc-set__price').textContent = money(parseInt(opt.dataset.price, 10));
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.lmc-set__add') : null;
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('.lmc-set');
    var sel = card.querySelector('.lmc-set__size');
    var id = sel ? sel.value : card.dataset.variant;
    var msg = card.querySelector('.lmc-set__msg');
    if (!id) { if (sel) sel.focus(); return; }

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding';
    if (msg) msg.textContent = '';

    var drawer = document.querySelector('cart-drawer');
    var onCart = /\/cart\/?$/.test(window.location.pathname);
    var useDrawer = drawer && typeof drawer.renderContents === 'function' && !onCart;
    var body = { items: [{ id: parseInt(id, 10), quantity: 1, properties: { _set: 'complete-the-set' } }] };
    if (useDrawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        btn.textContent = 'Added';
        if (!useDrawer) { window.location.reload(); return; }
        drawer.classList.remove('is-empty');
        drawer.renderContents(j);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        if (msg) msg.textContent = (err && (err.description || err.message)) || 'Could not add it. Try again.';
      });
  });
})();
